import { useTranslation } from 'react-i18next'

const useDropdownTranslations = () => {
	const { t } = useTranslation()

	const translateDropdownOptions = <T extends string>(
		optionsKey: string,
		options: { context: readonly T[] }
	) => {
		const dropdownOptions: Record<string, string> = {}
		for (const option of options.context) {
			// The translateDropdownOptions function is registered in
			// i18next.config.ts so keys will be picked up during extraction.
			// i18next-ignore-dynamic-key
			dropdownOptions[option] = t(optionsKey, {
				context: option,
			})
		}

		return dropdownOptions
	}

	return { translateDropdownOptions }
}

export { useDropdownTranslations }
